import { ItemPackNameEnum } from '@/graphql/purchase-plus/generated/purchasePlus_graphql'

export const packNameValues = [
  { key: 'null', value: '--' },
  ...Object.values(ItemPackNameEnum).map((value) => ({
    key: value,
    value: value,
  })),
]
